/* eslint-disable import/no-anonymous-default-export */
import { ChatAction, ChatActionTypes } from 'actions/data/chat';

const INITIAL_STATE = {
  currentChatUser: {},
  chatItemList: [],
};

export default function (chatState = INITIAL_STATE, action: ChatAction) {
  switch (action.type) {
    case ChatActionTypes.SET_CURRENT_CHAT_USER:
      return {
        ...chatState,
        currentChatUser: action.data,
      };

    case ChatActionTypes.SET_CHAT_ITEM_LIST:
      return {
        ...chatState,
        chatItemList: action.data,
      };

    default:
      return chatState;
  }
}
